<template>
  <!-- Header -->
  <div class="header">
    <!-- Logo -->
    <div class="header-left">
      <router-link to="/admin/index" class="logo">
        <img src="@/assets/admin_img/logo.png" alt="Logo" />
      </router-link>
      <router-link to="/admin/index" class="logo logo-small">
        <img
          src="@/assets/admin_img/logo-small.png"
          alt="Logo"
          width="30"
          height="30"
        />
      </router-link>
    </div>
    <!-- /Logo -->

    <a href="javascript:void(0);" id="toggle_btn">
      <align-left-icon size="1x" class="custom-class"></align-left-icon>
    </a>

    <div class="top-nav-search">
      <form>
        <input type="text" class="form-control" placeholder="Search here" />
        <button class="btn" type="submit"><i class="fa fa-search"></i></button>
      </form>
    </div>

    <!-- Mobile Menu Toggle -->
    <a class="mobile_btn" id="mobile_btn">
      <i class="fa fa-bars"></i>
    </a>
    <!-- /Mobile Menu Toggle -->

    <!-- Header Right Menu -->
    <ul class="nav user-menu">
      <!-- Notifications -->
      <li class="nav-item dropdown noti-dropdown">
        <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
          <bell-icon size="1.5x" class="custom-class"></bell-icon>
          <span class="badge badge-pill">3</span>
        </a>
        <div class="dropdown-menu notifications">
          <div class="topnav-dropdown-header">
            <span class="notification-title">Notifications</span>
            <a href="javascript:void(0)" class="clear-noti"> Clear All </a>
          </div>
          <div class="noti-content">
            <ul class="notification-list">
              <li class="notification-message">
                <a href="#">
                  <div class="media">
                    <span class="avatar avatar-sm">
                      <img
                        class="avatar-img rounded-circle"
                        alt="User Image"
                        src="@/assets/admin_img/doctors/doctor-thumb-01.jpg"
                      />
                    </span>
                    <div class="media-body">
                      <p class="noti-details">
                        <span class="noti-title">Dr. Ruby Perrin</span> Schedule
                        <span class="noti-title">her appointment</span>
                      </p>
                      <p class="noti-time">
                        <span class="notification-time">4 mins ago</span>
                      </p>
                    </div>
                  </div>
                </a>
              </li>
              <li class="notification-message">
                <a href="#">
                  <div class="media">
                    <span class="avatar avatar-sm">
                      <img
                        class="avatar-img rounded-circle"
                        alt="User Image"
                        src="@/assets/admin_img/patients/patient1.jpg"
                      />
                    </span>
                    <div class="media-body">
                      <p class="noti-details">
                        <span class="noti-title">Charlene Reed</span> has booked
                        her appointment to
                        <span class="noti-title">Dr. Ruby Perrin</span>
                      </p>
                      <p class="noti-time">
                        <span class="notification-time">6 mins ago</span>
                      </p>
                    </div>
                  </div>
                </a>
              </li>
              <li class="notification-message">
                <a href="#">
                  <div class="media">
                    <span class="avatar avatar-sm">
                      <img
                        class="avatar-img rounded-circle"
                        alt="User Image"
                        src="@/assets/admin_img/patients/patient2.jpg"
                      />
                    </span>
                    <div class="media-body">
                      <p class="noti-details">
                        <span class="noti-title">Travis Trimble</span> sent a
                        amount of $210 for his
                        <span class="noti-title">appointment</span>
                      </p>
                      <p class="noti-time">
                        <span class="notification-time">8 mins ago</span>
                      </p>
                    </div>
                  </div>
                </a>
              </li>
              <li class="notification-message">
                <a href="#">
                  <div class="media">
                    <span class="avatar avatar-sm">
                      <img
                        class="avatar-img rounded-circle"
                        alt="User Image"
                        src="@/assets/admin_img/patients/patient3.jpg"
                      />
                    </span>
                    <div class="media-body">
                      <p class="noti-details">
                        <span class="noti-title">Carl Kelly</span> send a
                        message <span class="noti-title"> to his doctor</span>
                      </p>
                      <p class="noti-time">
                        <span class="notification-time">12 mins ago</span>
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <div class="topnav-dropdown-footer">
            <a href="#">View all Notifications</a>
          </div>
        </div>
      </li>
      <!-- /Notifications -->

      <!-- User Menu -->
      <li class="nav-item dropdown has-arrow">
        <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
          <span class="user-img"
            ><img
              class="rounded-circle"
              src="@/assets/admin_img/profiles/avatar-01.jpg"
              width="31"
              alt="Ryan Taylor"
          /></span>
        </a>
        <div class="dropdown-menu">
          <div class="user-header">
            <div class="avatar avatar-sm">
              <img
                src="@/assets/admin_img/profiles/avatar-01.jpg"
                alt="User Image"
                class="avatar-img rounded-circle"
              />
            </div>
            <div class="user-text">
              <h6>Ryan Taylor</h6>
              <p class="text-muted mb-0">Administrator</p>
            </div>
          </div>
          <router-link class="dropdown-item" to="/admin/profile"
            >My Profile</router-link
          >
          <router-link class="dropdown-item" to="/admin/settings"
            >Settings</router-link
          >
          <router-link class="dropdown-item" to="/admin/login"
            >Logout</router-link
          >
        </div>
      </li>
      <!-- /User Menu -->
    </ul>
    <!-- /Header Right Menu -->
  </div>
  <!-- /Header -->
</template>
<script>
import { AlignLeftIcon } from "vue-feather-icons";
import { BellIcon } from "vue-feather-icons";
export default {
  components: {
    AlignLeftIcon,
    BellIcon,
  },
  mounted() {
    // Variables declarations
    var $wrapper = $(".main-wrapper");

    $("body").append('<div class="sidebar-overlay"></div>');
    $(document).on("click", "#mobile_btn", function() {
      $wrapper.toggleClass("slide-nav");
      $(".sidebar-overlay").toggleClass("opened");
      $("html").addClass("menu-opened");
      $("#task_window").removeClass("opened");
      return false;
    });

    $(document).on("click", ".top-nav-search .responsive-search", function() {
      $(".top-nav-search").toggleClass("active");
    });
    $(".sidebar-menu ul li:not(.submenu) a").click(function() {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
    });
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layouts/HeaderAdmin.vue